import { render, staticRenderFns } from "./asset_type_field.vue?vue&type=template&id=42313bb9&"
import script from "./asset_type_field.vue?vue&type=script&lang=js&"
export * from "./asset_type_field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports